export enum AHTextFonts {
  REGULAR = "Inter-Regular",
  BOLD = "Inter-SemiBold",
  LIGHT = "Inter-Light",
  MEDIUM = "Inter-Medium",
  MONO = "SF-Mono-Light",
  BOLDER = "Inter-ExtraBold",
  ITALIC = "Caveat-SemiBold",
}
